/* tslint:disable */

declare var Object: any;
export interface HistoricalInspectionInterface {
  "inspectorId"?: string;
  "pictures"?: any;
  "procedureType"?: string;
  "certificationData"?: any;
  "imageRecognitionData"?: any;
  "inspectionForm"?: any;
  "agentCode"?: string;
  "licencePlate"?: string;
  "clientName"?: string;
  "vehicleType"?: string;
  "transactionId"?: string;
  "tokenId"?: string;
  "province"?: string;
  "date"?: Date;
  "isSuccessful"?: boolean;
  "successfulMsgList"?: any;
  "failedMsgList"?: any;
  "id"?: any;
}

export class HistoricalInspection implements HistoricalInspectionInterface {
  "inspectorId": string;
  "pictures": any;
  "procedureType": string;
  "certificationData": any;
  "imageRecognitionData": any;
  "inspectionForm": any;
  "agentCode": string;
  "licencePlate": string;
  "clientName": string;
  "vehicleType": string;
  "transactionId": string;
  "tokenId": string;
  "province": string;
  "date": Date;
  "isSuccessful": boolean;
  "successfulMsgList": any;
  "failedMsgList": any;
  "id": any;
  constructor(data?: HistoricalInspectionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `HistoricalInspection`.
   */
  public static getModelName() {
    return "HistoricalInspection";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of HistoricalInspection for dynamic purposes.
  **/
  public static factory(data: HistoricalInspectionInterface): HistoricalInspection{
    return new HistoricalInspection(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'HistoricalInspection',
      plural: 'HistoricalInspections',
      path: 'HistoricalInspections',
      idName: 'id',
      properties: {
        "inspectorId": {
          name: 'inspectorId',
          type: 'string'
        },
        "pictures": {
          name: 'pictures',
          type: 'any'
        },
        "procedureType": {
          name: 'procedureType',
          type: 'string'
        },
        "certificationData": {
          name: 'certificationData',
          type: 'any'
        },
        "imageRecognitionData": {
          name: 'imageRecognitionData',
          type: 'any'
        },
        "inspectionForm": {
          name: 'inspectionForm',
          type: 'any'
        },
        "agentCode": {
          name: 'agentCode',
          type: 'string'
        },
        "licencePlate": {
          name: 'licencePlate',
          type: 'string'
        },
        "clientName": {
          name: 'clientName',
          type: 'string'
        },
        "vehicleType": {
          name: 'vehicleType',
          type: 'string'
        },
        "transactionId": {
          name: 'transactionId',
          type: 'string'
        },
        "tokenId": {
          name: 'tokenId',
          type: 'string'
        },
        "province": {
          name: 'province',
          type: 'string'
        },
        "date": {
          name: 'date',
          type: 'Date'
        },
        "isSuccessful": {
          name: 'isSuccessful',
          type: 'boolean',
          default: false
        },
        "successfulMsgList": {
          name: 'successfulMsgList',
          type: 'any'
        },
        "failedMsgList": {
          name: 'failedMsgList',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
